<template>
    <div id="chart-complete-rate">
    </div>
</template>
<script>

import ApexCharts from 'apexcharts'
import { getListExcerice, getListElectroniclecture, getListLessonPlaning } from './../../_api/lessonClassSchoolUserServices';

export default {
    name: 'ChartCompleteRate',
    components: { ApexCharts },
    props: {
        classId: {
            type: Number,
            default: 0
        },
        subjectId: {
            type: Number,
            default: 0
        },
        keyword: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            listDataBTBKT: [],
            listDataBGDT: [],
            listDataKHBD: [],
            isGetDataBTBKT: false,
            isGetDataBGDT: false,
            isGetDataKHBD: false,
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
                subjectId: 0,
                classId: 0,
            },
            options: {
                series: [
                    {
                        name: 'Đã hoàn thành',
                        data: [0, 0, 0]
                    },
                    {
                        name: 'Đang hoàn thành',
                        data: [0, 0, 0]
                    },
                    {
                        name: 'Chưa hoàn thành',
                        data: [0, 0, 0]
                    }
                ],
                chart: {
                    type: 'bar',
                    height: 330,
                    stacked: true,
                    stackType: '100%'
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        dataLabels: {
                            position: 'center', // top, center, bottom
                        },
                    },
                },
                xaxis: {
                    categories: ['Bài tập/bài kiểm tra', 'Bài giảng điện tử', 'Kế hoạch bài dạy'],
                },
                yaxis: {
                    title: {
                        text: 'Tỉ lệ %'
                    },
                    tickAmount: 5,
                    min: 0,
                    max: 100,
                },
                legend: { 
                    show: true,
                    itemMargin: {
                        horizontal: 15,
                        vertical: 0
                    },
                    onItemClick: {
                        toggleDataSeries: false
                    },
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                },
                colors: ['#145aa5', '#a055b9', '#f564a0'],
                noData: {
                    text: 'Đang tải dữ liệu biểu đồ...'
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(2) + "%"
                    },
                    
                }
            },
        }
    },
    watch: {
        'classId': 'getAll',
        'options.series': 'renderChart',
        'subjectId': 'getAll',
        'keyword': 'getAll',
        'isGetDataBTBKT': 'getListSeriesData',
        'isGetDataBGDT': 'getListSeriesData',
        'isGetDataKHBD': 'getListSeriesData',
    },
    mounted() {
        this.renderChart()
        if (this.classId > 0) {
            this.getAll()
        }
    },
    methods:{
        formatNumber(value){
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(2);
        },
        renderChart() {
            if (this.options.series.length > 0) {
                var chartElement = document.querySelector("#chart-complete-rate");
                chartElement.innerHTML = ''
                var chart = new ApexCharts(chartElement, this.options);
                chart.render();
            }
        },
        getListPoint() {
            let seriesDataCompleted = []
            let seriesDataIsBeingComplete = []
            let seriesDataNotSeen = []
            //Tính số bài theo tiến độ hoàn thành của Bài tập/bài kiểm tra
            if (this.listDataBTBKT.length > 0) {
                //đã hoàn thành
                let countCompleted = this.listDataBTBKT.filter(x => this.formatNumber(x.completeRate * 1) * 1 >= 100).length
                seriesDataCompleted.push(countCompleted);

                //đang hoàn thành
                let countIsBeingComplete = this.listDataBTBKT.filter(x => this.formatNumber(x.completeRate * 1) * 1 < 100 && this.formatNumber(x.completeRate * 1) * 1 > 0).length
                seriesDataIsBeingComplete.push(countIsBeingComplete);

                //chưa xem
                let countNotSeen = this.listDataBTBKT.length - countCompleted - countIsBeingComplete
                seriesDataNotSeen.push(countNotSeen);
            }
            else {
                seriesDataCompleted.push(0);
                seriesDataIsBeingComplete.push(0);
                seriesDataNotSeen.push(0);
            }

            //Tính số bài theo tiến độ hoàn thành của Bài giảng điện tử
            if (this.listDataBGDT.length > 0) {
                //đã hoàn thành
                let countCompleted = this.listDataBGDT.filter(x => this.formatNumber(x.completeRate * 1) * 1 >= 100).length
                seriesDataCompleted.push(countCompleted);

                //đang hoàn thành
                let countIsBeingComplete = this.listDataBGDT.filter(x => this.formatNumber(x.completeRate * 1) * 1 < 100 && this.formatNumber(x.completeRate * 1) * 1 > 0).length
                seriesDataIsBeingComplete.push(countIsBeingComplete);

                //chưa xem
                let countNotSeen = this.listDataBGDT.length - countCompleted - countIsBeingComplete
                seriesDataNotSeen.push(countNotSeen);
            }
            else {
                seriesDataCompleted.push(0);
                seriesDataIsBeingComplete.push(0);
                seriesDataNotSeen.push(0);
            }

            //Tính số bài theo tiến độ hoàn thành của Kế hoạch bài dạy
            if (this.listDataKHBD.length > 0) {
                //đã hoàn thành
                let countCompleted = this.listDataKHBD.filter(x => this.formatNumber(x.completeRate * 1) * 1 >= 100).length
                seriesDataCompleted.push(countCompleted);

                //đang hoàn thành
                let countIsBeingComplete = this.listDataKHBD.filter(x => this.formatNumber(x.completeRate * 1) * 1 < 100 && this.formatNumber(x.completeRate * 1) * 1 > 0).length
                seriesDataIsBeingComplete.push(countIsBeingComplete);

                //chưa xem
                let countNotSeen = this.listDataKHBD.length - countCompleted - countIsBeingComplete
                seriesDataNotSeen.push(countNotSeen);
            }
            else {
                seriesDataCompleted.push(0);
                seriesDataIsBeingComplete.push(0);
                seriesDataNotSeen.push(0);
            }

            this.options.series = [
                {
                    name: 'Đã hoàn thành',
                    data: seriesDataCompleted
                },
                {
                    name: 'Đang hoàn thành',
                    data: seriesDataIsBeingComplete
                },
                {
                    name: 'Chưa hoàn thành',
                    data: seriesDataNotSeen
                }
            ]
        },
        getListSeriesData() {
            if (this.isGetDataBTBKT && this.isGetDataBGDT && this.isGetDataKHBD) {
                this.getListPoint()
            }
        },
        getAll() {
            this.isGetDataBTBKT = false
            this.isGetDataBGDT = false
            this.isGetDataKHBD = false
            this.getListExerciseBySubjectId()
            this.getListElectronicLectureBySubjectId()
            this.getListLessonPlaningBySubjectId()
        },
        getListExerciseBySubjectId() {
            this.listDataBTBKT = []
            this.paramQueryData.subjectId = this.subjectId
            this.paramQueryData.keyword = this.keyword
            this.paramQueryData.classId = this.classId
            getListExcerice(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listDataBTBKT.push({ 
                            'stt': i + 1,
                            'classSchoolId': this.classSchoolId,
                            'subjectId':item.subjectId, 
                            'subjectName':item.subjectName,
                            'lessonName':item.lessonName,
                            'completeRate': (item.completeRate == 0 ? ((item.countAnswer || 0)/(item.countQuestion || 1)*100).toFixed(0) : item.completeRate),
                            'point': item.point,
                            'completeDate': item.completeDate,
                            'countQuestion': item.countQuestion,
                            'countAnswer': item.countAnswer,
                        })
                    }
                    this.isGetDataBTBKT = true
                }
            })
        },
        getListElectronicLectureBySubjectId() {
            this.listDataBGDT = []
            this.paramQueryData.subjectId = this.subjectId
            this.paramQueryData.keyword = this.keyword
            this.paramQueryData.classId = this.classId
            getListElectroniclecture(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listDataBGDT.push({ 
                            'stt': i + 1,
                            'classSchoolId': this.classSchoolId,
                            'subjectId':item.subjectId, 
                            'subjectName':item.subjectName,
                            'lessonName':item.lessonName,
                            'completeRate': item.completeRate,
                            'completeDate': item.completeDate,
                        })
                    }
                    this.isGetDataBGDT = true
                }
            })
        },
        getListLessonPlaningBySubjectId() {
            this.listDataKHBD = []
            this.paramQueryData.subjectId = this.subjectId
            this.paramQueryData.keyword = this.keyword
            this.paramQueryData.classId = this.classId
            getListLessonPlaning(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listDataKHBD.push({ 
                            'stt': i + 1,
                            'classSchoolId': this.classSchoolId,
                            'subjectId':item.subjectId, 
                            'subjectName':item.subjectName,
                            'lessonName':item.lessonName,
                            'completeRate': item.completeRate,
                            'missionTrue': item.missionTrue,
                            'missionTotal': item.missionTotal,
                            'missionRate': item.completeRate * 1 >= 100 ? this.formatNumber((item.missionTrue || 0) / (item.missionTotal || 1) * 100) : null,
                            'completeDate': item.completeDate,
                        })
                    }
                    this.isGetDataKHBD = true
                }
            })
        }

    }
}
</script>
<style lang="scss" scoped>

</style>